import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
// import { DesignationsDto } from "./designations.dto";


export class DesignationStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}

